export default __webpack_public_path__ + "static/media/pasta.0710b65f.png";